export default __webpack_public_path__ + "static/media/vip-banner.11fe23fa.webp";